import { ReactElement } from 'react';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { CreateDatasetContainer } from '../../../modules/datasets/containers/CreateDataset.container';
import { CreateDatasetFilesContainer } from '../../../modules/datasets/containers/CreateDatasetFiles.container';

export const CreateDatasetView = (): ReactElement => (
  <DashboardContainer>
    <CreateDatasetContainer />
    <CreateDatasetFilesContainer />
  </DashboardContainer>
);
